import React from "react";
import { css } from "@emotion/react";

import NavLinkTag from "core/Components/Navigations/NavLinkTag";
import NavSubTextBox from "core/Components/Navigations/NavSubTextBox";

type Props = {
    subMenu: StandardPage,
    selectedSegments?: string[],
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    mouseClickHandler: Function,
};

const NavSubLink: React.FC<Props> = ({
    subMenu,
    selectedSegments = undefined,
    mouseClickHandler,
}) => {
    const style = css`
        margin: 5px 0;
        width: fit-content;
    `;

    return (
        <div css={style}>
            <NavLinkTag data={subMenu}>
                <NavSubTextBox
                    headerMenu={subMenu}
                    selectedSegments={selectedSegments}
                    mouseClickHandler={mouseClickHandler}
                >
                    {subMenu.title}
                </NavSubTextBox>
            </NavLinkTag>
        </div>
    );
};

export default NavSubLink;